<script setup>
import { useI18n } from 'vue-i18n'
const { t } = useI18n();
import { useRouter } from 'vue-router'
const router = useRouter()
const goBack = () => {
    router.go(-1);
}
const isMobile = ref(false);//false代表pc
onMounted(() => {
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    console.log('Is mobile device:', isMobile.value);
})
</script>
<template>
    <div :class="isMobile ? 'phone-pg' : ''">

        <div class="top" v-if="isMobile">
            <div @click="goBack()"><svg-icon icon-class="backfff" /></div>
            <div>{{ $t('setup130') }}</div>
            <div></div>
        </div>
        <div class="aboutUS">
            <div class="title" v-if="!isMobile">
                {{ $t('setup130') }}
            </div>
            <div class="sub-title" v-if="!isMobile">
                <div class="info-block">
                    <!-- <div class="company">{{ $t('setup139') }}
                    </div>
                    <div class="company-icon"></div> -->
                </div>

                <img src="../../../assets/images/bgus.png" alt="" srcset="">
            </div>
            <div class="company" v-if="isMobile">
                <div>{{ $t('setup139') }}</div>
            </div>
            <div class="info-text">

                <div class="line">
                    <div>{{ $t('setup140') }}</div>
                    <div>{{ $t('setup0140') }}</div>
                </div>
                <div class="line">
                    <div>{{ $t('setup141') }}</div>
                    <div>{{ $t('setup0141') }}</div>
                </div>
                <div class="line">
                    <div>{{ $t('setup142') }}</div>
                    <div>alin19991207@51shopy.com</div>
                </div>
                <!-- <div class="line">
                    <div>{{ $t('setup143') }}</div>
                    <div>{{ $t('setup0143') }}</div>
                </div>
                <div class="line">
                    <div>{{ $t('setup144') }}</div>
                    <div>{{ $t('setup0144') }}</div>
                </div> -->
            </div>
        </div>

    </div>
</template>

<style scoped lang="scss">
.phone {
    display: none;
}

.pc {
    display: block;
}

.el-rate {
    // --el-rate-void-color: #dadee8;
    --el-rate-height: 20px;
    // --el-rate-font-size: var(--el-font-size-base);
    --el-rate-icon-size: 21px;
    --el-rate-icon-margin: -2px;
    // --el-rate-void-color: var(--el-border-color-darker);
    --el-rate-fill-color: #FC7702;
    // --el-rate-disabled-void-color: var(--el-fill-color);
    // --el-rate-text-color: var(--el-text-color-primary);
    /* 使用深度选择器 */
    // ::v-deep .el-rate__item.is-disabled.is-active {
    // background: none; /* 移除默认的背景 */
    // border: 1px solid #FC7702; /* 设置边框颜色 */
    // }
}

.aboutUS {
    width: 100%;
}

.title {
    width: 194px;
    height: 36px;
    line-height: 36px;
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 18px;
    color: #11192D;
    text-align: left;
    font-style: normal;
}

.sub-title {
    width: 100%;
    border-radius: 10px;
    position: relative;
    margin: 20px 0 20px;

    >img {
        width: 100%;
        height: auto;

    }

    .info-block {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        padding: 0 30px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;

        .company {
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 24px;
            color: #FFFFFF;
            line-height: 31px;
            text-align: left;
            font-style: normal;
        }

        .company-icon {
            margin-top: 10px;
            width: 190px;
            height: 10px;
            background: linear-gradient(58deg, #FFFFFF 0%, rgba(216, 216, 216, 0) 100%);
            border-radius: 5px;
        }
    }



}

.info-text {
    padding: 0 30px;

    .line {
        display: flex;
        align-items: center;


        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #11192D;
        line-height: 36px;
        text-align: left;
        font-style: normal;

        >div:first-child {
            color: #666;
            width: 20%;
        }

        >div:last-child {
            width: 60%;
        }
    }
}

.phone-pg {
    background-image: url('@/assets/images/bgusphone.png');
    /* 背景图片覆盖整个容器，不留空白 */
    background-size: 100% auto;
    /* 背景图片不平铺 */
    background-repeat: no-repeat;
    background-color: #f3f3f3;
    width: 100%;
    height: 100vh;
   
    .company {
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 24px;
        color: #FFFFFF;
        line-height: 31px;
        text-align: left;
        font-style: normal;
        padding: 20px 10px 15px;
    }

    .info-text {
        background-color: #fff;
        border-radius: 8px;
        width: calc(100% - 20px);
        margin: 10px;
        height: calc(100vh - 250px);
        padding: 19px 17px;
        .line {
            >div:first-child {
                width: 30%;
            }
        }
    }
}

@media (max-width: 768px) {
    .pc {
        display: none !important;
    }

    .phone {
        display: block;
    }

    .top {
        display: flex;
        justify-content: space-between;
        height: 45px;
        align-items: center;
        padding: 0 20px;
        z-index: 999999;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #FFFFFF;
        line-height: 25px;
        font-style: normal;
    }
}
</style>